import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useContext } from 'react';
import { PageNavigatorContext } from "../PageNavigator";
import { ChevronNormalRight } from "../../icons";
import { Button } from './Button';
export var Next = function Next(_ref) {
  var restProps = _extends({}, _ref);

  var _useContext = useContext(PageNavigatorContext),
      activePage = _useContext.activePage,
      onChangePage = _useContext.onChangePage,
      totalItems = _useContext.totalItems,
      itemsPerPage = _useContext.itemsPerPage;

  var isDisabled = activePage === Math.ceil(totalItems / itemsPerPage);

  var handleClick = function handleClick() {
    return onChangePage(activePage + 1);
  };

  return /*#__PURE__*/React.createElement(Button, _extends({}, restProps, {
    disabled: isDisabled,
    onClick: handleClick
  }), /*#__PURE__*/React.createElement(ChevronNormalRight, null));
};